import DisableNotifications from '@/modules/notifications/models/disable-notifications.dto';
import IUserNotificationsPreferencesResponse from '@/modules/notifications/models/get-user-notifications-preferences.dto';
import { JButton } from '@atoms/JButton';
import { disableCvVideoNotification } from '@constants';
import { Stack, Switch, Typography } from '@mui/material';
import { UseMutateFunction } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type disableNotificationMutationType = UseMutateFunction<
  AxiosResponse<null, any>,
  unknown,
  { userId: string | undefined; payload: DisableNotifications },
  unknown
>;

interface PreferencesDialogBodyProps {
  onClose: () => void;
  title: string;
  caption: string;
  userId: string | undefined;
  userNotificationsResponse: IUserNotificationsPreferencesResponse | undefined;
  disableNotificationMutation: disableNotificationMutationType;
}

const PreferencesDialogBody = ({
  onClose,
  title,
  caption,
  userId,
  userNotificationsResponse,
  disableNotificationMutation,
}: PreferencesDialogBodyProps) => {
  const { t } = useTranslation();
  const [isDirty, setIsDirty] = useState(false);
  const [enableNotification, setEnableNotification] = useState(true);

  useEffect(() => {
    setEnableNotification(
      !userNotificationsResponse?.notifications?.includes(
        disableCvVideoNotification.cvVideo,
      ),
    );
  }, [userNotificationsResponse]);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsDirty(true);
    setEnableNotification(e.target.checked);
  };
  const handleConfirm = () => {
    !enableNotification
      ? disableNotificationMutation({
          userId,
          payload: {
            notificationsCategory: [disableCvVideoNotification.cvVideo],
          },
        })
      : disableNotificationMutation({
          userId,
          payload: { notificationsCategory: [] },
        });

    onClose();
  };
  return (
    <>
      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row" alignItems="center" gap={8}>
          <Stack>
            <Typography variant="h4">{title}</Typography>
            <Typography variant="caption">{caption}</Typography>
          </Stack>
          <Switch
            color="primary"
            checked={enableNotification}
            onChange={handleOnChange}
          />
        </Stack>
      </Stack>
      <Stack direction={'row'} gap={1} mt={2}>
        <JButton
          data-qa="confirm-preferences-button"
          onClick={handleConfirm}
          variant="contained"
          color="secondary"
          fullWidth
          disabled={!isDirty}
        >
          {t('SAVE')}
        </JButton>
        <JButton
          data-qa="close-preferences-button-dialog"
          onClick={onClose}
          variant="contained"
          color="info"
        >
          {t('CANCEL')}
        </JButton>
      </Stack>
    </>
  );
};

export default PreferencesDialogBody;
